import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function SiteContentPanel() {
  const [form, setForm] = useState({
    logo_text_left: 'Curb', logo_text_right: 'Alert',
    hero_title: '', hero_subtitle: '', welcome_message: '', cta_text: '',
    about_title: '', about_body: '',
    contact_title: '', contact_body: '', contact_email: '',
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get('/site-content').then(r => setForm(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put('/site-content', form); toast.success('Site content saved'); }
    catch { toast.error('Could not save'); }
    finally { setSaving(false); }
  };

  const field = (k, label, multiline) => (
    <div>
      <Label className="text-xs uppercase tracking-[0.2em] text-brand-dim">{label}</Label>
      {multiline
        ? <Textarea data-testid={`admin-${k}`} value={form[k] || ''} onChange={e => setForm({ ...form, [k]: e.target.value })} className="mt-2 rounded-xl min-h-[120px]" />
        : <Input data-testid={`admin-${k}`} value={form[k] || ''} onChange={e => setForm({ ...form, [k]: e.target.value })} className="mt-2 rounded-xl" />}
    </div>
  );

  return (
    <div data-testid="site-content-panel">
      <h2 className="font-display font-bold text-2xl text-brand-ink mb-1">Site content</h2>
      <p className="text-brand-slate text-sm mb-6">Edit the logo, hero copy, and the About / Contact pages.</p>
      <div className="glass-panel rounded-3xl p-6 space-y-5">
        <h3 className="font-display text-lg text-brand-ink">Branding &amp; hero</h3>
        <div className="grid grid-cols-2 gap-4">{field('logo_text_left', 'Logo · left')}{field('logo_text_right', 'Logo · right')}</div>
        {field('hero_title', 'Hero title')}
        {field('hero_subtitle', 'Hero subtitle', true)}
        {field('cta_text', 'CTA text')}
        {field('welcome_message', 'Welcome message')}
        <div className="pt-4 border-t border-black/5" />
        <h3 className="font-display text-lg text-brand-ink">About page</h3>
        {field('about_title', 'About · title')}
        {field('about_body', 'About · body', true)}
        <div className="pt-4 border-t border-black/5" />
        <h3 className="font-display text-lg text-brand-ink">Contact page</h3>
        {field('contact_title', 'Contact · title')}
        {field('contact_body', 'Contact · body', true)}
        {field('contact_email', 'Contact · email')}
        <div className="pt-2 flex justify-end">
          <Button data-testid="admin-save-btn" onClick={save} disabled={saving} className="rounded-full bg-brand hover:bg-brand-hover text-white px-6">
            {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />} Save changes
          </Button>
        </div>
      </div>
    </div>
  );
}
